<div class="modal-header">
  <h4 class="modal-title" id="confirm-modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  {{ body }}
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-white text-primary border-primary"
    ngbAutofocus
    (click)="activeModal.close('Nee')">
    {{ negative }}
  </button>
  <button id="confirmModalJa" type="button" class="btn btn-primary" (click)="activeModal.close('Ja')">
    {{ positive }}
  </button>
</div>
